import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["buttonUse", "className", "inlineSize", "isVirtualizedMenu", "variant"];
import { Select } from 'foundations-components/transitional/components/Select';
import { virtualizedMenuRenderer } from 'foundations-components/transitional/utils/virtualizedMenuRenderer';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { InputWrapper } from '../InputWrapper/InputWrapper';
import { LayoutBox } from '../Layout/LayoutBox';
import { jsx as _jsx } from "react/jsx-runtime";
export function SelectBase(_ref) {
  let {
      buttonUse,
      className,
      inlineSize = '100%',
      isVirtualizedMenu = false,
      variant
    } = _ref,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(restWithSpacingProps);
  let menuRenderer = undefined;
  if (isVirtualizedMenu) {
    menuRenderer = virtualizedMenuRenderer;
  }

  /**
   * @todo remove className wrapper once we support data-test-id
   * @see https://git.hubteam.com/HubSpot/foundations-components/issues/5148
   */
  return /*#__PURE__*/_jsx(LayoutBox, {
    className: className,
    inlineSize: inlineSize,
    children: /*#__PURE__*/_jsx(Select, Object.assign({}, rest, spacingProps, {
      buttonUse: variant || buttonUse,
      inlineSize: inlineSize,
      menuRenderer: menuRenderer
    }))
  });
}
export const SelectWrapper = props => /*#__PURE__*/_jsx(InputWrapper, Object.assign({}, props));
SelectWrapper.displayName = 'InputWrapper';